/* eslint-disable sonarjs/cognitive-complexity */
import * as React from 'react';

import { Input } from '@/components/input';
import { SearchButtonAdvanced, SearchFilter } from '@/components/search-button-advanced';
import { SelectorAPI } from '@/components/selector-api';
import { SelectorDateRange } from '@/components/selector-daterange';

enum FilterType {
  DateRange = 'dateRange',
  Company = 'company',
  Contact = 'contact',
  Project = 'project',
  Mixer = 'mixer',
  Titles = 'titles',
  VoTalent = 'voTalent'
}

interface Properties {
  moveRight?: boolean;
  draggable?: boolean;
  disabled?: boolean;
}

function validateSearchArray(searchArray: any[]) {
  let errorsUpdate: Record<string, string> = {};

  for (const [index, search] of searchArray.entries()) {
    switch (search.type) {
      case FilterType.DateRange: {
        if (!search.startDate) errorsUpdate = { ...errorsUpdate, [index + '_startDate']: 'No Start Date Selected!' };
        if (!search.endDate) errorsUpdate = { ...errorsUpdate, [index + '_endDate']: 'No End Date Selected!' };
        break;
      }
      case FilterType.Company: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_companyId']: 'No Company Selected!' };
        break;
      }
      case FilterType.Contact: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_contactId']: 'No Contact Selected!' };
        break;
      }
      case FilterType.Project: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_projectId']: 'No Project Selected!' };
        break;
      }
      case FilterType.Mixer: {
        if (!search.id) errorsUpdate = { ...errorsUpdate, [index + '_mixerId']: 'No Mixer Selected!' };
        break;
      }
      case FilterType.Titles: {
        if (!search.name) errorsUpdate = { ...errorsUpdate, [index + '_titles']: 'No Titles Search Entered!' };
        break;
      }
      case FilterType.VoTalent: {
        if (!search.name) errorsUpdate = { ...errorsUpdate, [index + '_voTalent']: 'No VO Talent Search Entered!' };
        break;
      }
    }
  }

  return errorsUpdate;
}

function renderFilter(filter: SearchFilter, index: number) {
  switch (filter.type) {
    case FilterType.DateRange: {
      return <SelectorDateRange value={{ startDate: filter.startDate, endDate: filter.endDate }} index={index} />;
    }
    case FilterType.Company: {
      return <SelectorAPI name={index + '_company'} displayName='Company' value={filter.id} fetchURL='/companies' />;
    }
    case FilterType.Contact: {
      return <SelectorAPI name={index + '_contact'} displayName='Contact' value={filter.id} fetchURL='/contacts' />;
    }
    case FilterType.Project: {
      return <SelectorAPI name={index + '_project'} displayName='Project' value={filter.id} fetchURL='/projects' />;
    }
    case FilterType.Mixer: {
      return <SelectorAPI name={index + '_mixer'} displayName='Mixer' value={filter.id} fetchURL='/users/mixers' />;
    }
    case FilterType.Titles: {
      return <Input name={index + '_titles'} displayName='Titles' value={filter.name} />;
    }
    case FilterType.VoTalent: {
      return <Input name={index + '_voTalent'} displayName='VO Talent' value={filter.name} />;
    }
    default: {
      return;
    }
  }
}

export function SearchButtonWorkOrders({ moveRight = false, draggable = false, disabled = false }: Properties) {
  const filtersAvailable = [
    FilterType.DateRange,
    FilterType.Company,
    FilterType.Contact,
    FilterType.Project,
    FilterType.Mixer,
    FilterType.Titles,
    FilterType.VoTalent
  ];

  return (
    <SearchButtonAdvanced
      modalTitle='Search Work Orders'
      formId='adv-search-workorders'
      filtersAvailable={filtersAvailable}
      filterLabels={{ [FilterType.VoTalent]: 'VO Talent' }}
      renderFilter={renderFilter}
      validateSearchArray={validateSearchArray}
      moveRight={moveRight}
      draggable={draggable}
      disabled={disabled}
    />
  );
}
